import { createContext } from 'react';
export default /*#__PURE__*/createContext(undefined);